export default __webpack_public_path__ + "static/media/b.cefb6921.png";